export default __webpack_public_path__ + "static/media/nye-promo.d11b9cd0.jpeg";